import { createKsStore, type KsStoreHook } from '@siclop/kstone-vue'
import { Team } from '../models/Team'
import { TeamForm } from '../forms/TeamForm'
import { TeamFilter } from '../filters/TeamFilter'
import { TeamService } from '../services/TeamService'

export const useTeamStore: KsStoreHook<Team, TeamForm, TeamFilter> = createKsStore({
  id: 'teams',
  modelClass: Team,
  formClass: TeamForm,
  filterClass: TeamFilter,
  service: TeamService,
  uniqueField: 'code',
  labelField: (item) => item.label || item.code || `Équipe #${item.id}`,
  signalREventName: 'TeamModel'
})
